import { useGoogleLogin } from '@react-oauth/google';
import { useStore } from 'zustand';
import { useUnityBuildStore } from '../stores/store';
import { clients } from '../clients/grpcClients';
import { useLocalStorage } from '../stores/localStorage';
import { useQueryClient } from 'react-query';
import { resetAuthFailedState } from './useStopSyncOnAuthError';

export function useGoogle_Login() {
  const queryClient = useQueryClient();
  const setSessionToken = useStore(useLocalStorage).setSessionToken;
  const setIsFetchingToken = useStore(useLocalStorage).setIsFetchingToken;
  const { setIsLoggedIn, setProjectListIsMounted } = useStore(useUnityBuildStore);
  const login = useGoogleLogin({
    onSuccess: codeResponse => handleSetToken(codeResponse),
    flow: 'auth-code',
    onError: error => console.error(error),
  });

  const handleSetToken = async (codeResponse: any) => {
    try {
      // Clear all before starting a new login
      // This is critical for switching between accounts without browser refresh
      localStorage.clear();
      queryClient.clear();
      queryClient.resetQueries();

      // Reset auth failed state since we're trying to login
      resetAuthFailedState();

      setIsFetchingToken(true);
      try {
        clients.getUserTokenRequest.setCode(codeResponse.code);
      } catch (error) {
        console.error('error', error);
      }

      // Make the gRPC call
      let response = null;
      try {
        response = await clients.userTokenServiceClient.getToken(clients.getUserTokenRequest);
      } catch (error) {
        console.error('error', error);
      }

      if (response && response.getSessionToken()) {
        setIsFetchingToken(false);
        setSessionToken(response.getSessionToken());
        setIsLoggedIn(true);
        setProjectListIsMounted(true);

        // Make sure to reset any auth failed state after successful login
        resetAuthFailedState();
      } else {
        setIsFetchingToken(false);
        setSessionToken('');
        setIsLoggedIn(false);
        setProjectListIsMounted(false);
      }
    } catch (error) {
      console.error('error', error);
      setIsFetchingToken(false);
    }
  };

  return login;
}
